<div mat-dialog-title>
    {{headerLabel}}
</div>

<mat-dialog-content>

    <div class="row" style="min-height:75px;" style="justify-content:space-between; position:relative;">

        <div>
            <tyl-form-field label="Layout Name">
                <input #txtNameRef matInput id='txtLayoutName' type='text' [(ngModel)]='layout.Name' (change)="layoutNameChanged()"
                    name="layoutName" required />
            </tyl-form-field>
        </div>

        <div *ngIf="!v10 && layout.Id <= 0">
            <tyl-form-field label="Layout Type">
                <mat-select id='ddlLayoutType' [(ngModel)]='layoutType' (selectionChange)="layoutTypeChanged()">
                    <mat-option *ngFor='let type of layoutTypes' [value]='type'>
                        {{type.Name.replace("Academic History","")}}
                    </mat-option>
                </mat-select>
            </tyl-form-field>
        </div>

        <div>
            <tyl-form-field label="Description" hint="{{200 - layout.Description.length}} characters left"
                style="width:300px;">
                <textarea matInput id='txtLayoutDescription' type='text' [(ngModel)]='layout.Description'
                    name="layoutName" maxlength="200" rows="3" style="width:300px;"></textarea>
            </tyl-form-field>
        </div>

        <div>
            <span>Scope</span>
            
            <mat-radio-group [(ngModel)]="layout.Scope" class="flex-column">
                <div>
                    <mat-radio-button [value]="'Private'">
                        Private
                    </mat-radio-button>
                </div>
                <div>
                    <mat-radio-button [value]="'Selected Sites'">
                        Available to
                        <a (click)="selectedSitesClick()" [class.disabled]="layout.Scope != 'Selected Sites'">
                            Selected Sites
                        </a>
                    </mat-radio-button>
                </div>
                <div>
                    <mat-radio-button [value]="'District'">
                        Available to District
                    </mat-radio-button>
                </div>
            </mat-radio-group>
        </div>
    </div>

    <div style="flex:1;" class="row">
        <ng-container *ngFor="let section of layout.Sections; let i = index">
            <div id="divSection{{i}}" *ngIf="section.ShowOnEditor" class="col">
                <div style="display: flex;flex-direction: row;">
                    <span style="width: 70%;">
                        {{section.Name}}
                    </span>
                    <tyl-checkbox style="width: 30%;" id='chkHideSection{{i}}' name='chkHideSection{{i}}'
                        [(checked)]='section.Hidden' (change)="hideSectionChange(section)"
                        *ngIf="!hideDisableCheck(section.Name)" [disabled]="section.ParentSectionIsHidden">
                        Hide section
                    </tyl-checkbox>
                </div>
                <tyl-form-field label="Add" [fullWidth]="true">
                    <mat-select id='ddlAdd{{i}}' [(value)]="selectedFields[i]" (selectionChange)="addField(section, i)"
                        [disabled]="section.Hidden">
                        <ng-container *ngFor='let field of section.AvailableFields'>
                            <mat-option *ngIf="field.Visible" [value]='field'>
                                {{field | getFieldDisplayName: dqFieldsRetrieved}}
                            </mat-option>
                        </ng-container>
                    </mat-select>
                </tyl-form-field>
                <div class="container">
                    <div class="nonDraggableList">
                        <div id="nonDraggableItem{{idx}}" style="width:100%; display:flex;"
                            *ngFor="let field of section.SelectedFields; let idx = index">
                            <div class="listItem"
                                *ngIf="field.SpecialFieldID > 0 && field.SpecialFieldID != colBreakFieldId && !isSpecialFieldDraggable(field)">
                                <div style="width:30px;"></div>
                                <div style="flex:1;">
                                    {{field | getFieldDisplayName: dqFieldsRetrieved}}
                                </div>
                                <button id="btnRemoveNonDraggable{{idx}}" mat-icon-button color="warn"
                                    (click)="!section.Hidden && removeItemClick(section, idx)">
                                    <mat-icon aria-hidden="true">
                                        clear
                                    </mat-icon>
                                </button>
                            </div>
                        </div>
                    </div>
                    <div cdkDropList (cdkDropListDropped)="drop($event, section)" class="fieldList">
                        <div id="draggableItem{{idx}}" style="width:100%; display:flex;"
                            *ngFor="let field of section.SelectedFields; let idx = index" cdkDrag
                            [cdkDragDisabled]="section.Hidden">
                            <div class="listItem draggable"
                                *ngIf="(field.DQFieldID > 0 || field.SpecialFieldID == colBreakFieldId || isSpecialFieldDraggable(field)) && getFieldDisplayName(field)">
                                <div class="placeholder" *cdkDragPlaceholder></div>
                                <div style="width:30px;"><img src="./assets/images/grip.png" style="padding-left:5px;">
                                </div>
                                <div style="flex:1;">
                                    {{field | getFieldDisplayName: dqFieldsRetrieved}}
                                </div>
                                <button id="btnRemove{{idx}}" mat-icon-button color="warn"
                                    (click)="!section.Hidden && removeItemClick(section, idx)"
                                    *ngIf="field.SpecialFieldID != colBreakFieldId && !field.RequiredForDisplay">
                                    <mat-icon aria-hidden="true">
                                        clear
                                    </mat-icon>
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </ng-container>
    </div>
    <div class="row">
        <ng-container *ngFor="let section of layout.Sections">
            <div class="col" *ngIf="section.ShowOnEditor">
                <span *ngIf="section.IsGrid">
                    Drag rows up and down to arrange them as columns on the grid.
                </span>
                <span *ngIf="!section.IsGrid">
                    Drag rows up and down to arrange them. Use the Column Break to split fields into columns.
                </span>
            </div>
        </ng-container>
    </div>
</mat-dialog-content>

<mat-dialog-actions>
    <div class='flex-footer-left'>
        <tyl-button image="startover.png" label="Revert Changes" (clickEvent)="revertChangesClick()"></tyl-button>
    </div>
    <div class='flex-footer-right'>
        <error-prompt [errorList]="errors"></error-prompt>
        <tyl-button image="save.png" label="Save" (clickEvent)="saveClick(true)"
            *ngIf="!layout.Id || layout.Id <= 0 || layout.Owner == userId"></tyl-button>
        <tyl-button image="save disabled.png" label="Save" [disabled]="true"
            *ngIf="layout.Id > 0 && layout.Owner != userId"></tyl-button>
        <tyl-button image="cancel.png" label="Cancel" (clickEvent)="cancelClick()"></tyl-button>
    </div>
</mat-dialog-actions>

<ng-template #scopeRadioTemplate let-value="value">
    <span *ngIf="value == 'Selected Sites'">
        Available to
        <a (click)="selectedSitesClick()" id="lnkSelectedSites">
            Selected Sites
        </a>
    </span>
</ng-template>